import { Avatar, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import CandidateDetailSkeleton from "./Listing/CandidateRightFullProfileInfo/CandidateDetailSkeleton";
import useTitle from "../../../../utilities/hooks/useTitle";
import ComplianceInfoIcon from "../../../Icons/ComplianceInfoIcon";

/**
 * Renders the basic information of a candidate.
 */
const BasicInfo = ({ profileShown = true }) => {
  const [candidateStatusUpdating, setCandidateStatusUpdating] = useState(false);
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const { candidateDetails, showProfile, candidateDetLoading } = useSelector(
    (state) => state.clientCandidateDetail,
  );

  const {
    candidate_name,
    profile_image,
    candidate_sortlisted,
    candidate_unsuitable,
    role_name,
    nmc_gmc_conditions,
    dbs_conditions,
    visa_restrictions,
  } = candidateDetails;

  useTitle(candidate_name + " | " + role_name);

  // Tool tip tags

  const conditions = [
    { label: "NMC/GMC conditions", show: candidateDetails?.nmc_gmc_conditions },
    { label: "Visa restrictions", show: candidateDetails?.visa_restrictions },
    { label: "DBS conditions", show: candidateDetails?.dbs_conditions },
  ];

  // Get active conditions
  const tooltipTitle = conditions
    .filter(({ show }) => show)
    .map(({ label }) => label)
    .join(" , ");

  return (
    <div
      className={`BasicInfo_Wrapper max-w-full ${!showProfile ? "hidden h-[0px] w-[0px]" : "transition-all duration-300"}`}
    >
      <div className={`${showProfile ? "" : ""} bg-lightblueBG px-4 py-4`}>
        <div className="flex items-center gap-4">
          {candidateDetLoading ? (
            <CandidateDetailSkeleton.candidateBasicInfo size={84} />
          ) : (
            <>
              <div className="relative flex flex-col items-center gap-1">
                <div className="relative">
                  <Avatar
                    alt={candidate_name}
                    src={profile_image}
                    sx={{ width: 88, height: 88 }}
                    className="border-4 border-primary"
                  />

                  {/* {
                      !clientUserAllPermissions || clientUserAllPermissions.is_allow_to_marking_candidate === 1 ? (
                        candidate_sortlisted == 1 ||
                          candidate_unsuitable == 1 ? (

                          <button
                            className={`absolute -bottom-1 -right-1 grid h-[30px] w-[30px] cursor-default place-items-center rounded-full border border-primary bg-white text-white transition-all duration-150 ease-in`}

                          >
                            {candidate_sortlisted == 1 ? (
                              candidateStatusUpdating ? <ButtonLoader spinnerColor="#ED3A3E" /> :
                                <StarFilledIcon cls="text-[#FFD680] w-[20px] h-[20px]" />
                            ) : candidate_unsuitable == 1 ? (
                              candidateStatusUpdating ? <ButtonLoader spinnerColor="#FFC446" /> :
                                <UnsuitableFilledIcon cls="text-[#E7585B] w-[20px] h-[20px]" />
                            ) : null}
                          </button>


                        ) : null
                      ) : null
                    } */}
                </div>
              </div>
              <div className="flex flex-col items-start justify-center gap-1">
                <div
                  className={`relative grid gap-3 ${!profileShown ? "grid-cols-[1fr_200px] items-end gap-[20px]" : ""}`}
                >
                  <div>
                    <h1 className="flex flex-wrap items-center gap-1 text-[18px] font-bold leading-[normal] text-black">
                      <span className="flex flex-wrap items-center gap-2">
                        {candidate_name}
                        {nmc_gmc_conditions ||
                        dbs_conditions ||
                        visa_restrictions ? (
                          <Tooltip
                            title={
                              <div
                                style={{
                                  whiteSpace: "pre-line",
                                  fontSize: "14px",
                                }}
                              >
                                {tooltipTitle}
                              </div>
                            }
                            placement="top"
                          >
                            <span>
                              <ComplianceInfoIcon
                                cls={"text-red w-[21px] h-[21px]"}
                              />
                            </span>
                          </Tooltip>
                        ) : null}
                      </span>
                    </h1>
                  </div>
                </div>

                <div
                  className={`grid gap-3 ${!profileShown ? "grid-cols-[1fr_203px] items-end gap-[20px]" : ""}`}
                >
                  <div className="flex items-center gap-2">
                    <span className="!text-[14px] font-semibold text-txtColor">
                      {role_name}
                    </span>
                  </div>

                  <div></div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
